import { Link } from 'react-router-dom';
import type { ContentItem } from '@/mocks/content';
import { formatShortDate } from '@/utils/content';

const tagIcon: Record<string, string> = {
  健康: 'ri-heart-pulse-line',
  美食: 'ri-restaurant-2-line',
  旅游: 'ri-flight-takeoff-line',
  购物: 'ri-shopping-bag-3-line',
};

export default function LifestyleTopics({ items }: { items: ContentItem[] }) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">生活服务推荐专题</h2>
          <p className="mt-1.5 text-sm text-foreground-600">健康、美食、旅游、购物，一站搞定日常所需</p>
        </div>
        <Link
          to="/lifestyle"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
          >
            <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900">
              <i className={`${tagIcon[item.tag] ?? 'ri-leaf-line'} text-xl`}></i>
            </span>
            <div className="min-w-0 flex-1">
              <div className="mb-1 flex items-center gap-2">
                <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-500">{formatShortDate(item.date)}</span>
              </div>
              <h3 className="line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                {item.title}
              </h3>
            </div>
            <i className="ri-arrow-right-s-line flex-shrink-0 text-xl text-foreground-400 transition-transform duration-300 group-hover:translate-x-1"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}